// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6f68241c","160":"e6aa7171","208":"7f709684","293":"aa292568","516":"aa1559f3","519":"4a9bc21f","917":"d0c7fb29","946":"7ad02e41"}[chunkId] + ".chunk.js";
};